import { ERROR400S } from './constants'

export const handleStatusError = function (err) {
  switch (err.response.status) {
    case ERROR400S.INTERNAL:
      return 'error:ERR_500'
    case ERROR400S.TIMEOUT:
      return 'error:errorTimeout'
    case ERROR400S.FORBIDDEN:
      return 'error:errorPermission'
  }
}
